module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"header":"Solicitar estorno"},"en-US":{"header":"Refund boleto"}}')
  delete Component.options._Ctor
}
